import { Button } from '@goodboydigital/astro';
import { NineSlicePlane, Sprite, Text, Texture } from 'pixi.js';

import { Shared } from '../../App';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    text: 'BUTTON',
    value: '',
    w: 350,
    h: 80,
    active: true,
    accessible: false,
    accessibleTitle: 'LanguageButton',
    tabIndex: 0,
};

export type LanguageButtonOpts = typeof defaultOpts;

export class LanguageButton extends Button
{
    public view: Sprite;
    public width: number;
    public height: number;
    public value: string;

    protected btn: NineSliceButton;

    private _active: boolean;

    private _btnActiveTexture: Texture;
    private _btnInactiveTexture: Texture;

    constructor(o: LanguageButtonOpts)
    {
        const view = new Sprite();

        super(view, o);

        this.view = view;
        this._active = o.active || false;

        this.view.anchor.set(0, 0.5);

        const icon = new Sprite();

        const text = new Text(o.text.toUpperCase(), {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 6,
            lineJoin: 'round',
            align: 'center',
            fontSize: 28,
        });

        text.anchor.set(0.5);
        icon.addChild(text);

        const offset = 50;

        this.btn = new NineSliceButton({
            icon,
            accessibleTitle: o.text,
            bgAsset: o.active ? 'button-ninesliced-magenta-clean' : 'button-ninesliced-grey-clean',
            nineSliceOffset: offset,
            w: o.w,
            h: o.h,
            hoverScale: 1.02,
            clickScale: 1.02,
        });

        this._btnActiveTexture = new NineSlicePlane(Shared.assets.getTexture('button-ninesliced-magenta-clean'),
            offset, offset, offset, offset,
        ).texture;

        this._btnInactiveTexture = new NineSlicePlane(Shared.assets.getTexture('button-ninesliced-grey-clean'),
            offset, offset, offset, offset,
        ).texture;

        this.view.addChild(this.btn.view);

        this.onPress.connect(() =>
        {
            this.state = !this._active;
        });

        this.width = o.w;
        this.height = o.h;

        this.value = o.value || o.text;
    }

    public get state(): boolean { return this._active; }
    public set state(state: boolean)
    {
        this._active = state;
        this.btn.bg.texture = this._active ? this._btnActiveTexture : this._btnInactiveTexture;
    }
}
